// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/search-results-item/search-results-item.component.scss
// module id = 492
// module chunks = 0